import { render } from "./dtl_page_subsidy.vue?vue&type=template&id=1c3dc73e&scoped=true"
import script from "./dtl_page_subsidy.vue?vue&type=script&lang=js"
export * from "./dtl_page_subsidy.vue?vue&type=script&lang=js"

import "./dtl_page_subsidy.vue?vue&type=style&index=0&id=1c3dc73e&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3dc73e"]])

export default __exports__